import types from '../types/start'
import timeslotTypes from '../types/timeslot'
import addressTypes from '../types/address'
import paymentMethodTypes from '../types/paymentMethod'
import {Map} from 'immutable'

const initialRoot = Map({
  transaction: null,
  isFetching: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.GET_TRANSACTION:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.GET_TRANSACTION_SUCCESS:
      return state.merge({
        transaction: Map(action.payload.transaction),
        isFetching: false,
        error: '',
      })
    case types.GET_TRANSACTION_FAIL:
      return state.merge({
        transaction: null,
        isFetching: false,
        error: action.payload.error,
      })
    case timeslotTypes.MODIFY_TRANSACTION_SUCCESS:
      const reserve = state.getIn(['transaction', 'Reserve'])
      reserve.Date = action.payload.date.toISOString()
      reserve.TimeSlot = action.payload.timeslot
      return state.setIn(['transaction', 'Reserve'], reserve)
    case addressTypes.MODIFY_TRANSACTION_SUCCESS:
      return state.set('transaction', state.get('transaction').set('ClientAddress', action.payload.address))
    case paymentMethodTypes.MODIFY_TRANSACTION_SUCCESS:
      return state.set('transaction', state.get('transaction').set('Card', action.payload.card))
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/deposit/reducers/start.js